export default __webpack_public_path__ + "static/media/authBannerImage.1983a2d1.png";